import { Injectable } from '@angular/core';
import {
  RudderAnalytics,
  RudderAnalyticsPreloader,
} from '@rudderstack/analytics-js/*';
import { fromEvent, Observable } from 'rxjs';
import { APEXX, CSEValidationResult } from 'src/app/typings/apexx';
import { Cardinal } from 'src/app/typings/songbird';
import { BBox } from 'src/app/typings/bbox';
import { KindlyChatTypes } from 'src/app/typings/kindly-chat';
import { Uplift } from 'src/app/typings/uplift';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  static get screenWidth(): number {
    return window.innerWidth;
  }

  /* istanbul ignore next  */
  static get screenHeight(): number {
    return window.innerHeight;
  }

  /* istanbul ignore next  */
  static back(): void {
    window.history.back();
  }

  static print(): void {
    window.print();
  }

  /* istanbul ignore next  */
  static reload(): void {
    window.location.reload();
  }

  static get navigator(): Navigator {
    return window.navigator;
  }

  static get localStorage(): Storage {
    return window.localStorage;
  }

  static get sessionStorage(): Storage {
    return window.sessionStorage;
  }

  static get storageEvent(): Observable<StorageEvent> {
    return fromEvent<StorageEvent>(window, 'storage');
  }

  /* istanbul ignore next  */
  static goTo(url: string): void {
    window.location.href = url;
  }

  /* istanbul ignore next  */
  static open(url: string, target?: string): void {
    window.open(url, target);
  }

  static getSelectedText(): string | undefined {
    if (window.getSelection) {
      return window.getSelection()?.toString();
    }
  }

  static showKindlyBubble(visible: boolean): void {
    if (window.kindlyChat) {
      visible
        ? window.kindlyChat?.showBubble()
        : window.kindlyChat?.hideBubble();
    }
  }

  static getBbox(): BBox {
    return window.bbox;
  }

  // static hasApplePaySession(): boolean {
  //   return !!window.ApplePaySession && ApplePaySession.canMakePayments();
  // }

}

declare global {
  interface Window {
    // ApplePaySession: ApplePaySession;
    bbox: BBox;
    kindlyChat: KindlyChatTypes;
    rudderanalytics: RudderAnalytics | RudderAnalyticsPreloader | undefined;
    tolstoyAppKey: string | undefined;
    tolstoyWidget: Object | undefined;
    Uplift: Uplift;
    _n0bs: number;
    cardDataEncryption: () => void;
    isValidCardHolderName: (cardHolderName: string) => CSEValidationResult;
    isValidCardNumber: (cardNumber: string) => CSEValidationResult;
    isValidCVV: (cvv: string) => CSEValidationResult;
    isValidMonth: (month: string) => CSEValidationResult;
    isValidYear: (year: string) => CSEValidationResult;
    luhnCheck: (cardNumber: string) => CSEValidationResult;
  }

  const APEXX : APEXX;
  const Cardinal: Cardinal;
}



window.kindlyChat = window.kindlyChat || null;
// window.ApplePaySession = window.ApplePaySession || null;
